import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { createContext, useContext, useEffect } from 'react';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useRecommendations } from '../../hooks/useRecommendations';
import { useResultsPageOfferingsBi } from '../../hooks/useResultsPageOfferingsBi';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
const ResultsPageContext = /*#__PURE__*/createContext(null);
export const useResultsPageContext = () => {
  const value = useContext(ResultsPageContext);
  if (!value) {
    throw new Error('useResultsPageContext must be used within a ResultsPageProvider');
  }
  return value;
};

// Non-throwing variant for components that may render outside a
// ResultsPageProvider (e.g. the header rendered standalone in stories).
export const useResultsPageContextSafe = () => useContext(ResultsPageContext);
export const ResultsPageProvider = _ref => {
  let biViewMode = _ref.biViewMode,
    _ref$reportGatePageLo = _ref.reportGatePageLoadEvents,
    reportGatePageLoadEvents = _ref$reportGatePageLo === void 0 ? true : _ref$reportGatePageLo,
    _ref$useReferralAddit = _ref.useReferralAdditionalInfoAsSearchOrigin,
    useReferralAdditionalInfoAsSearchOrigin = _ref$useReferralAddit === void 0 ? false : _ref$useReferralAddit,
    _ref$querySubmitPath = _ref.querySubmitPath,
    querySubmitPath = _ref$querySubmitPath === void 0 ? '/' : _ref$querySubmitPath,
    _ref$hideSearchBarSha = _ref.hideSearchBarShadowOnPartialMatch,
    hideSearchBarShadowOnPartialMatch = _ref$hideSearchBarSha === void 0 ? false : _ref$hideSearchBarSha,
    _ref$showSearchIcon = _ref.showSearchIcon,
    showSearchIcon = _ref$showSearchIcon === void 0 ? false : _ref$showSearchIcon,
    _ref$hideFilterChips = _ref.hideFilterChips,
    hideFilterChips = _ref$hideFilterChips === void 0 ? false : _ref$hideFilterChips,
    _ref$useCompactRecomm = _ref.useCompactRecommendationsLayout,
    useCompactRecommendationsLayout = _ref$useCompactRecomm === void 0 ? false : _ref$useCompactRecomm,
    deviceType = _ref.deviceType,
    productType = _ref.productType,
    children = _ref.children;
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  useDomainSearchGateBi({
    viewMode: biViewMode,
    reportGatePageLoadEvents,
    useReferralAdditionalInfoAsSearchOrigin
  });
  const _useRecommendations = useRecommendations({
      enableOnEmptyQuery: false,
      productType,
      enableEarlyExactMatch: true
    }),
    recommendations = _useRecommendations.recommendations,
    isLoading = _useRecommendations.isLoading,
    isLeadingCardLoading = _useRecommendations.isLeadingCardLoading,
    query = _useRecommendations.query,
    hasMore = _useRecommendations.hasNextPage,
    fetchNextPage = _useRecommendations.fetchNextPage,
    isFetchingNextPage = _useRecommendations.isFetchingNextPage,
    error = _useRecommendations.error,
    biError = _useRecommendations.biError,
    onRetry = _useRecommendations.onRetry,
    isPricingLoading = _useRecommendations.isPricingLoading;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.useSuggestionActionResolver(),
    resolveActionForSuggestion = _DomainSearchSuiteMod.resolveActionForSuggestion;
  const _DomainSearchSuiteMod2 = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery(),
    updateUrl = _DomainSearchSuiteMod2.updateUrl;
  useQuerySubmit({
    path: querySubmitPath
  });
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    biError
  });
  useEffect(() => {
    return () => {
      CoreDomainSearchStore.resetStore();
    };
  }, []);
  const emptyQueryStatus = !isLoading && recommendations.length > 0 && !query;
  return /*#__PURE__*/React.createElement(ResultsPageContext.Provider, {
    value: {
      recommendations,
      isLoading,
      isLeadingCardLoading,
      query,
      hasMore,
      fetchNextPage,
      isFetchingNextPage,
      error,
      onRetry,
      isPricingLoading,
      emptyQueryStatus,
      updateUrl,
      resolveActionForSuggestion,
      hideSearchBarShadowOnPartialMatch,
      showSearchIcon,
      hideFilterChips,
      useCompactRecommendationsLayout,
      deviceType,
      productType
    }
  }, children);
};
//# sourceMappingURL=ResultsPageContext.js.map